export default __webpack_public_path__ + "static/media/download-icon.1f382acf.svg";